import { render, staticRenderFns } from "./DualInvestment.vue?vue&type=template&id=b6da4496&scoped=true&"
import script from "./DualInvestment.vue?vue&type=script&lang=ts&"
export * from "./DualInvestment.vue?vue&type=script&lang=ts&"
import style0 from "./DualInvestment.vue?vue&type=style&index=0&id=b6da4496&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6da4496",
  null
  
)

export default component.exports